import { render } from "./UserProfileShow.vue?vue&type=template&id=0ca4ac4c&scoped=true"
import script from "./UserProfileShow.vue?vue&type=script&lang=js"
export * from "./UserProfileShow.vue?vue&type=script&lang=js"

import "./UserProfileShow.vue?vue&type=style&index=0&id=0ca4ac4c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca4ac4c"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/UserProfileShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ca4ac4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ca4ac4c', __exports__)) {
    api.reload('0ca4ac4c', __exports__)
  }
  
  module.hot.accept("./UserProfileShow.vue?vue&type=template&id=0ca4ac4c&scoped=true", () => {
    api.rerender('0ca4ac4c', render)
  })

}


export default __exports__